// 25 Location Pages - Unique SEO content for each town
// Each location has: unique meta, H1, intro, FAQs, AI Q&A, nearby towns for internal linking.
// Google Maps iframe is generated from geo coords.

import { birminghamLocations } from './birminghamLocations';
import { uxbridgeLocations } from './uxbridgeLocations';

const thamesValleyLocations = [
  {
    slug: "slough",
    name: "Slough",
    county: "Berkshire",
    postcodes: "SL1, SL2, SL3",
    geo: { lat: 51.5105, lng: -0.5950 },
    distance: "3 miles from Burnham HQ",
    nearby: ["windsor", "maidenhead", "burnham", "iver"]
  },
  {
    slug: "windsor",
    name: "Windsor",
    county: "Berkshire",
    postcodes: "SL4",
    geo: { lat: 51.4817, lng: -0.6090 },
    distance: "5 miles from Burnham HQ",
    nearby: ["slough", "ascot", "staines", "egham"]
  },
  {
    slug: "maidenhead",
    name: "Maidenhead",
    county: "Berkshire",
    postcodes: "SL6",
    geo: { lat: 51.5218, lng: -0.7196 },
    distance: "4 miles from Burnham HQ",
    nearby: ["taplow", "marlow", "burnham", "slough"]
  },
  {
    slug: "burnham",
    name: "Burnham",
    county: "Buckinghamshire",
    postcodes: "SL1 7, SL1 8",
    geo: { lat: 51.5431, lng: -0.6511 },
    distance: "Local HQ location",
    nearby: ["taplow", "stoke-poges", "slough", "maidenhead"]
  },
  {
    slug: "taplow",
    name: "Taplow",
    county: "Buckinghamshire",
    postcodes: "SL6 0",
    geo: { lat: 51.5398, lng: -0.6900 },
    distance: "2 miles from Burnham HQ",
    nearby: ["burnham", "maidenhead", "marlow", "slough"]
  },
  {
    slug: "gerrards-cross",
    name: "Gerrards Cross",
    county: "Buckinghamshire",
    postcodes: "SL9",
    geo: { lat: 51.5872, lng: -0.5583 },
    distance: "7 miles from Burnham HQ",
    nearby: ["beaconsfield", "chalfont-st-peter", "amersham", "uxbridge"]
  },
  {
    slug: "beaconsfield",
    name: "Beaconsfield",
    county: "Buckinghamshire",
    postcodes: "HP9",
    geo: { lat: 51.6093, lng: -0.6431 },
    distance: "8 miles from Burnham HQ",
    nearby: ["gerrards-cross", "amersham", "high-wycombe", "marlow"]
  },
  {
    slug: "amersham",
    name: "Amersham",
    county: "Buckinghamshire",
    postcodes: "HP6, HP7",
    geo: { lat: 51.6742, lng: -0.6074 },
    distance: "14 miles from Burnham HQ",
    nearby: ["chalfont-st-peter", "beaconsfield", "high-wycombe", "gerrards-cross"]
  },
  {
    slug: "uxbridge",
    name: "Uxbridge",
    county: "Greater London",
    postcodes: "UB8, UB9, UB10",
    geo: { lat: 51.5463, lng: -0.4785 },
    distance: "9 miles from Burnham HQ",
    nearby: ["iver", "gerrards-cross", "slough", "richmond"]
  },
  {
    slug: "high-wycombe",
    name: "High Wycombe",
    county: "Buckinghamshire",
    postcodes: "HP10, HP11, HP12, HP13, HP14",
    geo: { lat: 51.6286, lng: -0.7490 },
    distance: "12 miles from Burnham HQ",
    nearby: ["marlow", "beaconsfield", "amersham", "maidenhead"]
  },
  {
    slug: "marlow",
    name: "Marlow",
    county: "Buckinghamshire",
    postcodes: "SL7",
    geo: { lat: 51.5710, lng: -0.7749 },
    distance: "7 miles from Burnham HQ",
    nearby: ["maidenhead", "high-wycombe", "henley-on-thames", "taplow"]
  },
  {
    slug: "henley-on-thames",
    name: "Henley-on-Thames",
    county: "Oxfordshire",
    postcodes: "RG9",
    geo: { lat: 51.5375, lng: -0.9035 },
    distance: "14 miles from Burnham HQ",
    nearby: ["marlow", "reading", "wokingham", "maidenhead"]
  },
  {
    slug: "reading",
    name: "Reading",
    county: "Berkshire",
    postcodes: "RG1, RG2, RG4, RG6, RG30",
    geo: { lat: 51.4543, lng: -0.9781 },
    distance: "18 miles from Burnham HQ",
    nearby: ["wokingham", "bracknell", "henley-on-thames", "maidenhead"]
  },
  {
    slug: "bracknell",
    name: "Bracknell",
    county: "Berkshire",
    postcodes: "RG12, RG42",
    geo: { lat: 51.4150, lng: -0.7535 },
    distance: "14 miles from Burnham HQ",
    nearby: ["wokingham", "ascot", "reading", "windsor"]
  },
  {
    slug: "wokingham",
    name: "Wokingham",
    county: "Berkshire",
    postcodes: "RG40, RG41",
    geo: { lat: 51.4112, lng: -0.8342 },
    distance: "17 miles from Burnham HQ",
    nearby: ["reading", "bracknell", "henley-on-thames", "ascot"]
  },
  {
    slug: "ascot",
    name: "Ascot",
    county: "Berkshire",
    postcodes: "SL5",
    geo: { lat: 51.4082, lng: -0.6732 },
    distance: "9 miles from Burnham HQ",
    nearby: ["sunningdale", "windsor", "bracknell", "egham"]
  },
  {
    slug: "sunningdale",
    name: "Sunningdale",
    county: "Berkshire",
    postcodes: "SL5 0",
    geo: { lat: 51.3942, lng: -0.6420 },
    distance: "10 miles from Burnham HQ",
    nearby: ["ascot", "egham", "staines", "windsor"]
  },
  {
    slug: "staines",
    name: "Staines",
    county: "Surrey",
    postcodes: "TW18, TW19",
    geo: { lat: 51.4345, lng: -0.5089 },
    distance: "9 miles from Burnham HQ",
    nearby: ["egham", "chertsey", "windsor", "sunningdale"]
  },
  {
    slug: "egham",
    name: "Egham",
    county: "Surrey",
    postcodes: "TW20",
    geo: { lat: 51.4320, lng: -0.5511 },
    distance: "8 miles from Burnham HQ",
    nearby: ["staines", "chertsey", "windsor", "sunningdale"]
  },
  {
    slug: "chertsey",
    name: "Chertsey",
    county: "Surrey",
    postcodes: "KT16",
    geo: { lat: 51.3888, lng: -0.5070 },
    distance: "11 miles from Burnham HQ",
    nearby: ["staines", "egham", "sunningdale", "richmond"]
  },
  {
    slug: "iver",
    name: "Iver",
    county: "Buckinghamshire",
    postcodes: "SL0",
    geo: { lat: 51.5220, lng: -0.5080 },
    distance: "5 miles from Burnham HQ",
    nearby: ["slough", "uxbridge", "richmond", "gerrards-cross"]
  },
  {
    slug: "farnham-common",
    name: "Farnham Common",
    county: "Buckinghamshire",
    postcodes: "SL2 3",
    geo: { lat: 51.5530, lng: -0.6270 },
    distance: "2 miles from Burnham HQ",
    nearby: ["stoke-poges", "burnham", "beaconsfield", "slough"]
  },
  {
    slug: "stoke-poges",
    name: "Stoke Poges",
    county: "Buckinghamshire",
    postcodes: "SL2 4",
    geo: { lat: 51.5430, lng: -0.5840 },
    distance: "2 miles from Burnham HQ",
    nearby: ["farnham-common", "burnham", "slough", "gerrards-cross"]
  },
  {
    slug: "chalfont-st-peter",
    name: "Chalfont St Peter",
    county: "Buckinghamshire",
    postcodes: "SL9 9",
    geo: { lat: 51.6080, lng: -0.5550 },
    distance: "7 miles from Burnham HQ",
    nearby: ["gerrards-cross", "amersham", "beaconsfield", "uxbridge"]
  },
  {
    slug: "richmond",
    name: "Richmond",
    county: "Greater London",
    postcodes: "TW9, TW10",
    geo: { lat: 51.4613, lng: -0.3037 },
    distance: "17 miles from Burnham HQ",
    nearby: ["staines", "uxbridge", "chertsey", "egham"]
  },
  // === Phase 2 Thames Valley + commuter-belt SEO expansion (26 new towns) ===
  {
    slug: "aylesbury",
    name: "Aylesbury",
    county: "Buckinghamshire",
    postcodes: "HP18, HP19, HP20, HP21, HP22",
    geo: { lat: 51.8168, lng: -0.8124 },
    distance: "25 miles from Burnham HQ • approx. 45 min drive",
    nearby: ["high-wycombe", "amersham", "milton-keynes", "leighton-buzzard"]
  },
  {
    slug: "milton-keynes",
    name: "Milton Keynes",
    county: "Buckinghamshire",
    postcodes: "MK1–MK19",
    geo: { lat: 52.0406, lng: -0.7594 },
    distance: "35 miles from Burnham HQ • approx. 55 min drive",
    nearby: ["aylesbury", "leighton-buzzard", "bicester", "amersham"]
  },
  {
    slug: "oxford",
    name: "Oxford",
    county: "Oxfordshire",
    postcodes: "OX1, OX2, OX3, OX4",
    geo: { lat: 51.7520, lng: -1.2577 },
    distance: "35 miles from Burnham HQ • approx. 55 min drive",
    nearby: ["abingdon", "bicester", "henley-on-thames", "reading"]
  },
  {
    slug: "bicester",
    name: "Bicester",
    county: "Oxfordshire",
    postcodes: "OX26, OX27",
    geo: { lat: 51.9001, lng: -1.1525 },
    distance: "40 miles from Burnham HQ • approx. 1 hr drive",
    nearby: ["oxford", "milton-keynes", "aylesbury", "abingdon"]
  },
  {
    slug: "abingdon",
    name: "Abingdon",
    county: "Oxfordshire",
    postcodes: "OX14",
    geo: { lat: 51.6713, lng: -1.2826 },
    distance: "38 miles from Burnham HQ • approx. 1 hr drive",
    nearby: ["oxford", "bicester", "reading", "henley-on-thames"]
  },
  {
    slug: "woking",
    name: "Woking",
    county: "Surrey",
    postcodes: "GU21, GU22",
    geo: { lat: 51.3199, lng: -0.5581 },
    distance: "18 miles from Burnham HQ • approx. 35 min drive",
    nearby: ["guildford", "weybridge", "kingston-upon-thames", "camberley"]
  },
  {
    slug: "guildford",
    name: "Guildford",
    county: "Surrey",
    postcodes: "GU1, GU2",
    geo: { lat: 51.2362, lng: -0.5704 },
    distance: "23 miles from Burnham HQ • approx. 45 min drive",
    nearby: ["woking", "camberley", "farnborough", "weybridge"]
  },
  {
    slug: "weybridge",
    name: "Weybridge",
    county: "Surrey",
    postcodes: "KT13",
    geo: { lat: 51.3713, lng: -0.4584 },
    distance: "14 miles from Burnham HQ • approx. 30 min drive",
    nearby: ["kingston-upon-thames", "woking", "chertsey", "staines"]
  },
  {
    slug: "kingston-upon-thames",
    name: "Kingston upon Thames",
    county: "Greater London",
    postcodes: "KT1, KT2",
    geo: { lat: 51.4120, lng: -0.3007 },
    distance: "18 miles from Burnham HQ • approx. 40 min drive",
    nearby: ["richmond", "twickenham", "weybridge", "woking"]
  },
  {
    slug: "camberley",
    name: "Camberley",
    county: "Surrey",
    postcodes: "GU15, GU16, GU17",
    geo: { lat: 51.3358, lng: -0.7432 },
    distance: "18 miles from Burnham HQ • approx. 35 min drive",
    nearby: ["farnborough", "woking", "guildford", "bracknell"]
  },
  {
    slug: "farnborough",
    name: "Farnborough",
    county: "Hampshire",
    postcodes: "GU14",
    geo: { lat: 51.2907, lng: -0.7540 },
    distance: "20 miles from Burnham HQ • approx. 40 min drive",
    nearby: ["camberley", "guildford", "basingstoke", "woking"]
  },
  {
    slug: "southampton",
    name: "Southampton",
    county: "Hampshire",
    postcodes: "SO14, SO15, SO16, SO17, SO18, SO19",
    geo: { lat: 50.9097, lng: -1.4044 },
    distance: "65 miles from Burnham HQ • approx. 1 hr 25 min drive via M3",
    nearby: ["basingstoke", "guildford", "farnborough"]
  },
  {
    slug: "basingstoke",
    name: "Basingstoke",
    county: "Hampshire",
    postcodes: "RG21, RG22, RG23, RG24",
    geo: { lat: 51.2667, lng: -1.0876 },
    distance: "32 miles from Burnham HQ • approx. 50 min drive",
    nearby: ["reading", "farnborough", "camberley", "guildford"]
  },
  {
    slug: "hounslow",
    name: "Hounslow",
    county: "Greater London",
    postcodes: "TW3, TW4, TW5",
    geo: { lat: 51.4684, lng: -0.3610 },
    distance: "14 miles from Burnham HQ • approx. 30 min drive",
    nearby: ["feltham", "twickenham", "northolt", "richmond"]
  },
  {
    slug: "feltham",
    name: "Feltham",
    county: "Greater London",
    postcodes: "TW13, TW14",
    geo: { lat: 51.4456, lng: -0.4105 },
    distance: "12 miles from Burnham HQ • approx. 25 min drive",
    nearby: ["hounslow", "twickenham", "staines", "richmond"]
  },
  {
    slug: "twickenham",
    name: "Twickenham",
    county: "Greater London",
    postcodes: "TW1, TW2",
    geo: { lat: 51.4461, lng: -0.3315 },
    distance: "16 miles from Burnham HQ • approx. 35 min drive",
    nearby: ["richmond", "hounslow", "feltham", "kingston-upon-thames"]
  },
  {
    slug: "northolt",
    name: "Northolt",
    county: "Greater London",
    postcodes: "UB5",
    geo: { lat: 51.5484, lng: -0.3680 },
    distance: "12 miles from Burnham HQ • approx. 25 min drive",
    nearby: ["wembley", "harrow", "hayes", "ealing"]
  },
  {
    slug: "wembley",
    name: "Wembley",
    county: "Greater London",
    postcodes: "HA0, HA9",
    geo: { lat: 51.5577, lng: -0.2960 },
    distance: "16 miles from Burnham HQ • approx. 35 min drive",
    nearby: ["harrow", "northolt", "ealing", "hayes"]
  },
  {
    slug: "harrow",
    name: "Harrow",
    county: "Greater London",
    postcodes: "HA1, HA2, HA3",
    geo: { lat: 51.5802, lng: -0.3416 },
    distance: "14 miles from Burnham HQ • approx. 30 min drive",
    nearby: ["wembley", "northolt", "rickmansworth", "watford"]
  },
  {
    slug: "ealing",
    name: "Ealing",
    county: "Greater London",
    postcodes: "W5, W13",
    geo: { lat: 51.5130, lng: -0.3089 },
    distance: "15 miles from Burnham HQ • approx. 30 min drive",
    nearby: ["hayes", "northolt", "wembley", "hounslow"]
  },
  {
    slug: "hayes",
    name: "Hayes",
    county: "Greater London",
    postcodes: "UB3, UB4",
    geo: { lat: 51.5133, lng: -0.4219 },
    distance: "10 miles from Burnham HQ • approx. 20 min drive",
    nearby: ["northolt", "ealing", "uxbridge", "feltham"]
  },
  {
    slug: "watford",
    name: "Watford",
    county: "Hertfordshire",
    postcodes: "WD17, WD18, WD19, WD24, WD25",
    geo: { lat: 51.6565, lng: -0.3903 },
    distance: "18 miles from Burnham HQ • approx. 35 min drive",
    nearby: ["rickmansworth", "hemel-hempstead", "st-albans", "harrow"]
  },
  {
    slug: "rickmansworth",
    name: "Rickmansworth",
    county: "Hertfordshire",
    postcodes: "WD3",
    geo: { lat: 51.6400, lng: -0.4722 },
    distance: "15 miles from Burnham HQ • approx. 30 min drive",
    nearby: ["watford", "chesham", "amersham", "harrow"]
  },
  {
    slug: "chesham",
    name: "Chesham",
    county: "Buckinghamshire",
    postcodes: "HP5",
    geo: { lat: 51.7060, lng: -0.6116 },
    distance: "17 miles from Burnham HQ • approx. 35 min drive",
    nearby: ["amersham", "rickmansworth", "aylesbury", "high-wycombe"]
  },
  {
    slug: "hemel-hempstead",
    name: "Hemel Hempstead",
    county: "Hertfordshire",
    postcodes: "HP1, HP2, HP3",
    geo: { lat: 51.7526, lng: -0.4692 },
    distance: "22 miles from Burnham HQ • approx. 40 min drive",
    nearby: ["watford", "st-albans", "rickmansworth", "chesham"]
  },
  {
    slug: "st-albans",
    name: "St Albans",
    county: "Hertfordshire",
    postcodes: "AL1, AL2, AL3, AL4",
    geo: { lat: 51.7520, lng: -0.3360 },
    distance: "25 miles from Burnham HQ • approx. 45 min drive",
    nearby: ["watford", "hemel-hempstead", "rickmansworth", "harrow"]
  },
  {
    slug: "leighton-buzzard",
    name: "Leighton Buzzard",
    county: "Bedfordshire",
    postcodes: "LU7",
    geo: { lat: 51.9166, lng: -0.6611 },
    distance: "30 miles from Burnham HQ • approx. 50 min drive",
    nearby: ["milton-keynes", "aylesbury", "hemel-hempstead", "st-albans"]
  },
  // === Phase 3 — Village expansion (15 long-tail SEO villages near HQ) ===
  {
    slug: "datchet",
    name: "Datchet",
    county: "Berkshire",
    postcodes: "SL3 9",
    geo: { lat: 51.4831, lng: -0.5806 },
    distance: "5 miles from Burnham HQ • approx. 12 min drive",
    nearby: ["windsor", "slough", "wraysbury", "iver"],
    isVillage: true
  },
  {
    slug: "dorney",
    name: "Dorney",
    county: "Buckinghamshire",
    postcodes: "SL4 6",
    geo: { lat: 51.4944, lng: -0.6677 },
    distance: "3 miles from Burnham HQ • approx. 8 min drive",
    nearby: ["burnham", "windsor", "taplow", "eton-wick"],
    isVillage: true
  },
  {
    slug: "eton-wick",
    name: "Eton Wick",
    county: "Berkshire",
    postcodes: "SL4 6",
    geo: { lat: 51.4881, lng: -0.6280 },
    distance: "4 miles from Burnham HQ • approx. 10 min drive",
    nearby: ["windsor", "dorney", "slough", "taplow"],
    isVillage: true
  },
  {
    slug: "wraysbury",
    name: "Wraysbury",
    county: "Berkshire",
    postcodes: "TW19 5",
    geo: { lat: 51.4566, lng: -0.5460 },
    distance: "7 miles from Burnham HQ • approx. 15 min drive",
    nearby: ["staines", "windsor", "datchet", "egham"],
    isVillage: true
  },
  {
    slug: "cookham",
    name: "Cookham",
    county: "Berkshire",
    postcodes: "SL6 9",
    geo: { lat: 51.5575, lng: -0.7077 },
    distance: "5 miles from Burnham HQ • approx. 12 min drive",
    nearby: ["maidenhead", "marlow", "bourne-end", "taplow"],
    isVillage: true
  },
  {
    slug: "bourne-end",
    name: "Bourne End",
    county: "Buckinghamshire",
    postcodes: "SL8 5",
    geo: { lat: 51.5764, lng: -0.7138 },
    distance: "6 miles from Burnham HQ • approx. 14 min drive",
    nearby: ["marlow", "cookham", "wooburn-green", "maidenhead"],
    isVillage: true
  },
  {
    slug: "wooburn-green",
    name: "Wooburn Green",
    county: "Buckinghamshire",
    postcodes: "HP10 0",
    geo: { lat: 51.5867, lng: -0.6900 },
    distance: "5 miles from Burnham HQ • approx. 12 min drive",
    nearby: ["bourne-end", "flackwell-heath", "high-wycombe", "beaconsfield"],
    isVillage: true
  },
  {
    slug: "flackwell-heath",
    name: "Flackwell Heath",
    county: "Buckinghamshire",
    postcodes: "HP10 9",
    geo: { lat: 51.6043, lng: -0.7081 },
    distance: "7 miles from Burnham HQ • approx. 15 min drive",
    nearby: ["high-wycombe", "wooburn-green", "penn", "beaconsfield"],
    isVillage: true
  },
  {
    slug: "penn",
    name: "Penn",
    county: "Buckinghamshire",
    postcodes: "HP10 8",
    geo: { lat: 51.6362, lng: -0.6713 },
    distance: "9 miles from Burnham HQ • approx. 18 min drive",
    nearby: ["beaconsfield", "high-wycombe", "flackwell-heath", "amersham"],
    isVillage: true
  },
  {
    slug: "hedgerley",
    name: "Hedgerley",
    county: "Buckinghamshire",
    postcodes: "SL2 3",
    geo: { lat: 51.5787, lng: -0.6018 },
    distance: "3 miles from Burnham HQ • approx. 8 min drive",
    nearby: ["farnham-common", "stoke-poges", "gerrards-cross", "beaconsfield"],
    isVillage: true
  },
  {
    slug: "hazlemere",
    name: "Hazlemere",
    county: "Buckinghamshire",
    postcodes: "HP15 7",
    geo: { lat: 51.6520, lng: -0.7290 },
    distance: "11 miles from Burnham HQ • approx. 22 min drive",
    nearby: ["high-wycombe", "holmer-green", "amersham", "penn"],
    isVillage: true
  },
  {
    slug: "holmer-green",
    name: "Holmer Green",
    county: "Buckinghamshire",
    postcodes: "HP15 6",
    geo: { lat: 51.6680, lng: -0.7050 },
    distance: "12 miles from Burnham HQ • approx. 23 min drive",
    nearby: ["hazlemere", "amersham", "high-wycombe", "chesham"],
    isVillage: true
  },
  {
    slug: "prestwood",
    name: "Prestwood",
    county: "Buckinghamshire",
    postcodes: "HP16 9",
    geo: { lat: 51.7034, lng: -0.7247 },
    distance: "14 miles from Burnham HQ • approx. 28 min drive",
    nearby: ["amersham", "high-wycombe", "wendover", "princes-risborough"],
    isVillage: true
  },
  {
    slug: "princes-risborough",
    name: "Princes Risborough",
    county: "Buckinghamshire",
    postcodes: "HP27 0",
    geo: { lat: 51.7253, lng: -0.8330 },
    distance: "18 miles from Burnham HQ • approx. 32 min drive",
    nearby: ["high-wycombe", "wendover", "aylesbury", "prestwood"],
    isVillage: true
  },
  {
    slug: "wendover",
    name: "Wendover",
    county: "Buckinghamshire",
    postcodes: "HP22 6",
    geo: { lat: 51.7615, lng: -0.7400 },
    distance: "20 miles from Burnham HQ • approx. 35 min drive",
    nearby: ["aylesbury", "princes-risborough", "amersham", "prestwood"],
    isVillage: true
  }
];

// Central London — served by the London branch (Great Russell Street WC1B 3PA).
// NOTE: /removals-london stays as the Greater-London COUNTY hub page; this
// entry exists to power the 4 service×London combo pages + branch-aware contact.
const londonLocation = {
  slug: "london",
  name: "London",
  county: "Greater London",
  postcodes: "WC1, WC2, EC1–EC4, SW1, W1, NW1, N1, E1, E14",
  geo: { lat: 51.5182506, lng: -0.1260886 },
  distance: "Local — our London branch is on Great Russell Street, Bloomsbury WC1B 3PA",
  nearby: ["uxbridge", "richmond", "twickenham", "watford"],
  branch: "london",
};

// The busiest London neighbourhoods get dedicated /removals-{slug} landing
// pages + 4 service combos each. All served by the London branch (WC1B 3PA).
const londonNeighbourhoods = [
  {
    slug: "camden",
    name: "Camden",
    county: "Greater London",
    postcodes: "NW1, NW5",
    geo: { lat: 51.539, lng: -0.1426 },
    distance: "1.5 miles from our London branch (Great Russell Street WC1B 3PA) • approx. 10 min drive",
    nearby: ["islington", "hampstead", "westminster", "shoreditch"],
    branch: "london",
  },
  {
    slug: "canary-wharf",
    name: "Canary Wharf",
    county: "Greater London",
    postcodes: "E14",
    geo: { lat: 51.5054, lng: -0.0235 },
    distance: "5 miles from our London branch (Great Russell Street WC1B 3PA) • approx. 25 min drive",
    nearby: ["shoreditch", "islington", "clapham", "westminster"],
    branch: "london",
  },
  {
    slug: "islington",
    name: "Islington",
    county: "Greater London",
    postcodes: "N1, N1C, N5",
    geo: { lat: 51.5362, lng: -0.1033 },
    distance: "2 miles from our London branch (Great Russell Street WC1B 3PA) • approx. 12 min drive",
    nearby: ["camden", "shoreditch", "hampstead", "westminster"],
    branch: "london",
  },
  {
    slug: "westminster",
    name: "Westminster",
    county: "Greater London",
    postcodes: "SW1, SW1A, SW1P, SW1V, SW1W",
    geo: { lat: 51.4975, lng: -0.1357 },
    distance: "1.7 miles from our London branch (Great Russell Street WC1B 3PA) • approx. 12 min drive",
    nearby: ["chelsea", "camden", "clapham", "islington"],
    branch: "london",
  },
  {
    slug: "chelsea",
    name: "Chelsea",
    county: "Greater London",
    postcodes: "SW3, SW10",
    geo: { lat: 51.4875, lng: -0.1687 },
    distance: "3.5 miles from our London branch (Great Russell Street WC1B 3PA) • approx. 20 min drive",
    nearby: ["westminster", "clapham", "camden", "canary-wharf"],
    branch: "london",
  },
  {
    slug: "shoreditch",
    name: "Shoreditch",
    county: "Greater London",
    postcodes: "E1, E2, EC2A",
    geo: { lat: 51.5265, lng: -0.0796 },
    distance: "2.5 miles from our London branch (Great Russell Street WC1B 3PA) • approx. 15 min drive",
    nearby: ["islington", "canary-wharf", "camden", "clapham"],
    branch: "london",
  },
  {
    slug: "clapham",
    name: "Clapham",
    county: "Greater London",
    postcodes: "SW4, SW11, SW12",
    geo: { lat: 51.462, lng: -0.138 },
    distance: "4.5 miles from our London branch (Great Russell Street WC1B 3PA) • approx. 25 min drive",
    nearby: ["chelsea", "westminster", "canary-wharf", "shoreditch"],
    branch: "london",
  },
  {
    slug: "hampstead",
    name: "Hampstead",
    county: "Greater London",
    postcodes: "NW3, NW6",
    geo: { lat: 51.556, lng: -0.178 },
    distance: "3.5 miles from our London branch (Great Russell Street WC1B 3PA) • approx. 20 min drive",
    nearby: ["camden", "islington", "westminster", "watford"],
    branch: "london",
  },
  // High-value neighbourhood pages (June 2026 — GSC-demand build)
  {
    slug: "covent-garden",
    name: "Covent Garden",
    county: "Greater London",
    postcodes: "WC2, WC2E, WC2H",
    geo: { lat: 51.5117, lng: -0.123 },
    distance: "0.6 miles from our London branch (Great Russell Street WC1B 3PA) • approx. 6 min drive",
    nearby: ["kings-cross", "westminster", "marylebone", "islington"],
    branch: "london",
  },
  {
    slug: "notting-hill",
    name: "Notting Hill",
    county: "Greater London",
    postcodes: "W11, W2, W10",
    geo: { lat: 51.5117, lng: -0.2058 },
    distance: "3.4 miles from our London branch (Great Russell Street WC1B 3PA) • approx. 20 min drive",
    nearby: ["chelsea", "marylebone", "westminster", "hampstead"],
    branch: "london",
  },
  {
    slug: "marylebone",
    name: "Marylebone",
    county: "Greater London",
    postcodes: "W1U, W1G, NW1",
    geo: { lat: 51.5186, lng: -0.1509 },
    distance: "1.4 miles from our London branch (Great Russell Street WC1B 3PA) • approx. 10 min drive",
    nearby: ["camden", "westminster", "notting-hill", "kings-cross"],
    branch: "london",
  },
  {
    slug: "greenwich",
    name: "Greenwich",
    county: "Greater London",
    postcodes: "SE10, SE3",
    geo: { lat: 51.4816, lng: -0.0076 },
    distance: "6.8 miles from our London branch (Great Russell Street WC1B 3PA) • approx. 30 min drive",
    nearby: ["canary-wharf", "clapham", "shoreditch", "westminster"],
    branch: "london",
  },
  {
    slug: "kings-cross",
    name: "King's Cross",
    county: "Greater London",
    postcodes: "N1C, N1, WC1X",
    geo: { lat: 51.5316, lng: -0.1236 },
    distance: "1.1 miles from our London branch (Great Russell Street WC1B 3PA) • approx. 8 min drive",
    nearby: ["camden", "islington", "marylebone", "covent-garden"],
    branch: "london",
  },
  {
    slug: "caversham",
    name: "Caversham",
    county: "Berkshire",
    postcodes: "RG4",
    geo: { lat: 51.4672, lng: -0.9722 },
    distance: "1.2 miles from our Reading branch (15 Queens Walk RG1 7QF) • approx. 7 min drive",
    nearby: ["reading", "woodley", "henley-on-thames", "wokingham"],
    branch: "reading",
  },
  {
    slug: "woodley",
    name: "Woodley",
    county: "Berkshire",
    postcodes: "RG5",
    geo: { lat: 51.4526, lng: -0.9027 },
    distance: "3.6 miles from our Reading branch (15 Queens Walk RG1 7QF) • approx. 14 min drive",
    nearby: ["reading", "caversham", "wokingham", "bracknell"],
    branch: "reading",
  },
  {
    slug: "bletchley",
    name: "Bletchley",
    county: "Buckinghamshire",
    postcodes: "MK1, MK2, MK3",
    geo: { lat: 51.9944, lng: -0.7327 },
    distance: "3.9 miles from our Milton Keynes branch (Marlborough Gate MK9 3XA) • approx. 13 min drive",
    nearby: ["milton-keynes", "newport-pagnell", "leighton-buzzard", "aylesbury"],
    branch: "miltonkeynes",
  },
  {
    slug: "newport-pagnell",
    name: "Newport Pagnell",
    county: "Buckinghamshire",
    postcodes: "MK16",
    geo: { lat: 52.087, lng: -0.7223 },
    distance: "4.2 miles from our Milton Keynes branch (Marlborough Gate MK9 3XA) • approx. 12 min drive",
    nearby: ["milton-keynes", "bletchley", "leighton-buzzard", "aylesbury"],
    branch: "miltonkeynes",
  },
  {
    slug: "bray",
    name: "Bray",
    county: "Berkshire",
    postcodes: "SL6",
    geo: { lat: 51.5079, lng: -0.7012 },
    distance: "1.9 miles from our Maidenhead branch (39 Queen Street SL6 1NB) • approx. 8 min drive",
    nearby: ["maidenhead", "windsor", "cookham", "taplow"],
    branch: "maidenhead",
  },
  {
    slug: "headington",
    name: "Headington",
    county: "Oxfordshire",
    postcodes: "OX3",
    geo: { lat: 51.7628, lng: -1.2141 },
    distance: "2.8 miles from our Oxfordshire branch (Littlemore OX4 4TN) • approx. 12 min drive",
    nearby: ["oxford", "didcot", "abingdon", "bicester"],
    branch: "oxfordshire",
  },
  {
    slug: "didcot",
    name: "Didcot",
    county: "Oxfordshire",
    postcodes: "OX11",
    geo: { lat: 51.6062, lng: -1.241 },
    distance: "11 miles from our Oxfordshire branch (Littlemore OX4 4TN) • approx. 22 min drive",
    nearby: ["oxford", "abingdon", "headington", "henley-on-thames"],
    branch: "oxfordshire",
  },
];

// Merge Thames-Valley + Birmingham + Uxbridge locations.
// Each Birmingham/Uxbridge location carries `branch:` so branch-aware templates pick the right contact.
// Re-pointing the existing Thames-Valley `uxbridge` entry to branch:'uxbridge' (it's the literal Uxbridge branch HQ town).
const baseLocations = [...thamesValleyLocations, ...birminghamLocations, ...uxbridgeLocations, londonLocation, ...londonNeighbourhoods];
export const locations = baseLocations.map((l) =>
  l.slug === 'uxbridge' && !l.branch ? { ...l, branch: 'uxbridge' } : l
);

export const getLocationBySlug = (slug) => locations.find((l) => l.slug === slug);
